import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Separator, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Html } from '#src/app/shared/components/html';

import { ContributionCount } from './components/ContributionCount';
import { useImpactBox } from './hooks/useImpactBox';

export const ImpactBox: React.FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => {
	const {
		data: { heading, text },
	} = useImpactBox();

	return (
		<div
			className={cn(
				'border-stroke-weaker bg-background-raised flex flex-col items-start gap-3 overflow-hidden rounded-md border p-4',
				className,
			)}
			data-qa="impact-box"
		>
			<div className="flex w-full flex-col gap-2">
				<Text as="div" fontWeight="bold" size="medium" className="text-typography-information">
					{heading}
				</Text>
				<ContributionCount />
			</div>
			{(children || text) && <Separator className="m-0" />}
			{text && <Html html={text} as="div" />}
			{children}
		</div>
	);
};
